/**
 * Error Message Component
 * Hiển thị validation errors với animation
 */

import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FieldConfig } from '../../models/field-config.interface';
import { ValidationService } from '../../services/validation.service';

@Component({
    selector: 'app-form-error',
    template: `
    <div class="form-error-wrapper" *ngIf="shouldShowError" [@fadeInOut]>
      <span class="error-icon">
        <i class="fa fa-exclamation-circle"></i>
      </span>
      <span class="error-text">{{ errorMessage }}</span>
    </div>
  `,
    styleUrls: ['./error-message.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-5px)' }),
                animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-5px)' }))
            ])
        ])
    ]
})
export class ErrorMessageComponent implements OnChanges {
    @Input() control!: AbstractControl;
    @Input() fieldConfig!: FieldConfig;
    @Input() showOnTouched: boolean = true;
    @Input() showOnDirty: boolean = false;

    errorMessage: string = '';

    constructor(private validationService: ValidationService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['control']) {
            this.updateErrorMessage();

            // Subscribe to value changes
            this.control?.statusChanges?.subscribe(() => {
                this.updateErrorMessage();
            });
        }
    }

    get shouldShowError(): boolean {
        if (!this.control) {
            return false;
        }

        const hasError = this.control.invalid;
        const isTouched = this.control.touched;
        const isDirty = this.control.dirty;

        if (this.showOnDirty) {
            return hasError && isDirty;
        }

        if (this.showOnTouched) {
            return hasError && isTouched;
        }

        return hasError;
    }

    private updateErrorMessage(): void {
        if (this.control && this.fieldConfig) {
            this.errorMessage = this.validationService.getErrorMessage(this.control, this.fieldConfig);
        }
    }
}
